export default __webpack_public_path__ + "static/media/timeoutGif.0dbc89cc.gif";